import React, {Component} from "react";
import {AddClientAdAccountModal} from "./AddClientAdAccountModal";
import {Button} from "reactstrap";
import {FaIcon} from "../../FaIcon";

export class AddClientAdAccountButtonWithModal extends Component {
    renderButton() {
        const faIcon = this.props.buttonIconName ? <FaIcon iconName={this.props.buttonIconName}/> : null
        const text = this.props.buttonText
        const className = this.props.buttonClassName
        const buttonTitle = this.props.buttonTitle !== undefined ? this.props.buttonTitle : "";
        if(className)
            return (<Button className={className} onClick={() => {this.addClientAdAccountModal.toggle()}} title={buttonTitle} style={this.props.buttonStyle}>{faIcon}{text}</Button>)
        else
            return (<button onClick={() => {this.addClientAdAccountModal.toggle()}} style={this.props.buttonStyle} title={buttonTitle}>{faIcon}{text}</button>)
    }

    render() {
        return  <span>{this.renderButton()}
        <AddClientAdAccountModal ref={instance => {this.addClientAdAccountModal = instance;}}
                                 afterSuccessfulSubmit={this.props.afterSuccessfulSubmit}
                                 channel={this.props.channel}
                                 adAccountId={this.props.adAccountId}
                                 hasAgentModule={this.props.hasAgentModule}
        />
        </span>;
    }
}
